<skypro-message-request
  class="root"
  #messageRequestComponent
  [needSaveInProgressText]="needSaveInProgressText"
  [localStorageKey]="localStorageKey"
  [editMessageContent]="editMessageContent"
  [validationError]="
    (showMessageTooLongError$ | async)
      ? ('skyproCommunications.errorMessageTooLong'
        | transloco: { count: showMessageTooLongError$ | async }
        | skyUiTypograf)
      : showSendingError
        ? ('skyproCommunications.errorMessage' | transloco | skyUiTypograf)
        : null
  "
  [placeholder]="getPlaceholder() | skyUiTypograf"
  [isLoading]="isLoading$ | async"
  [showAuthorData]="false"
  [hasAutofocus]="hasAutofocus"
  [allowedAttachmentTypes]="allowedAttachmentTypes"
  [isMessengerMode]="isMessengerMode"
  [isTextareaDisabled]="isTextareaDisabled()"
  (submit)="isMessengerMode ? submit(submitActionType.submit) : undefined"
  (cancelEditing)="finishEditing.emit()"
>
  <div class="message-request-form-actions" customActions>
    @if (!isMessengerMode && canAskTutorOrAI && hasCallTutorButton) {
      <ds-button
        [disabled]="isSubmitDisabled$ | async"
        [spinner]="isLoading$ | async"
        (click)="submit(submitActionType.extraSubmit)"
        class="button-send"
        type="secondary"
        size="s"
        data-test="дополнительное подтверждение"
      >
        <ds-icon-time size="s" iconLeft></ds-icon-time>
        Спросить наставника
      </ds-button>
    }

    @if (!editMessageContent) {
      <ds-button
        [disabled]="isSubmitDisabled$ | async"
        [spinner]="isLoading$ | async"
        (click)="submit(submitActionType.submit)"
        class="button-send"
        type="primary"
        size="s"
        data-test="отправить"
      >
        @if (canAskTutorOrAI && hasCallTutorButton) {
          <ds-icon-lightning size="s" iconLeft></ds-icon-lightning>
        }
        {{
          thread
            ? canAskTutorOrAI && hasCallTutorButton
              ? 'Спросить Германа'
              : 'Ответить'
            : 'Задать вопрос'
        }}
      </ds-button>
    }

    @if (editMessageContent) {
      <ds-button
        type="secondary"
        size="s"
        data-test="отменить редактирование сообщения"
        (click)="finishEditing.emit()"
      >
        Отменить
      </ds-button>

      <ds-button
        [disabled]="isSubmitDisabled$ | async"
        [spinner]="isLoading$ | async"
        (click)="submit(submitActionType.submit)"
        class="button-send"
        type="primary"
        size="s"
        data-test="сохранить отредактированное сообщение"
      >
        Сохранить
      </ds-button>
    }
  </div>
</skypro-message-request>
